import { Box } from "@mui/system";
import React from "react";
import styles from "./textBoxCompOne.module.scss";
import PropTypes from "prop-types";

const TextBoxCompOne = (props) => {
  const {
    hasStar = false,
    headerText = "",
    subText = "",
    headerTextStyle = "",
    subTextStyle = "",
    onheaderClick = null,
    onsubtextClick = null,
  } = props;
  return (
    <Box className={styles.textBoxCompOneWrapper} data-testid="TextBoxCompOne">
      <Box
        className={`${styles.headerText} ${headerTextStyle}`}
        onClick={() => onheaderClick()}
      >
        {hasStar ? <span className={styles.star}>* &nbsp;</span> : ""}{" "}
        {headerText}
      </Box>
      <Box
        className={`${styles.subText} ${subTextStyle}`}
        onClick={() => onsubtextClick()}
      >
        {subText}
      </Box>
    </Box>
  );
};
export default TextBoxCompOne;
TextBoxCompOne.propTypes = {
  hasStar: PropTypes.any,
  headerText: PropTypes.any,
  subText: PropTypes.any,
  headerTextStyle: PropTypes.any,
  subTextStyle: PropTypes.any,
  onheaderClick: PropTypes.any,
  onsubtextClick: PropTypes.any,
};
